// ============================================================
// TMR Portal Admin — as colunas da planilha de Taxas da TMR
// ============================================================
import { bandLabel, formatRateValue } from '../../data/rateFormat';
import type { TmrRate } from '../../data/globalRates/contract';
import type { ExportColumn } from '../../lib/export/types';

/**
 * The global rate template as a spreadsheet (20 §9).
 *
 * The value goes out **twice**: once formatted as the screen shows it — the unit comes from the rate type,
 * never from the row (15 §5) — and once as a bare number, because a rate is the one thing in this file
 * somebody will want to sum or chart in Excel, and "1,50%" is text.
 */
export const GLOBAL_RATE_EXPORT_COLUMNS: ExportColumn<TmrRate>[] = [
  { header: 'Tipo de taxa', value: (r) => r.rateTypeName ?? String(r.rateTypeId) },
  { header: 'Motor de crédito', value: (r) => r.creditEngineTypeName ?? '' },
  { header: 'Faixa de parcelas', value: (r) => bandLabel(r) },
  { header: 'Valor', value: (r) => formatRateValue(r.value, r.rateTypeId) },
  { header: 'Valor (número)', value: (r) => r.value },
  { header: 'Sincronizada com o legado', value: (r) => r.legacySynced },
  { header: 'Taxa no legado', value: (r) => r.legacyTmrRateId },
  // The overlap is a defect in the template, not a property of the rate — and the one thing somebody
  // exports this list to hunt down.
  { header: 'Faixa sobreposta', value: (r) => r.overlapping },
];
